module.exports = __webpack_public_path__ + "static/media/Sidebar__events.2624416b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sidebar__events.svg
// module id = 594
// module chunks = 0